module.exports = __webpack_public_path__ + "media/images/emblems/Brissago-coat_of_arms-52ec2088134ee10f0c4a2a490f15b625.svg";